<template>
  <div>
    <div class="marginCenter">
      <el-form :model="form.applyBasic" :rules="rules" label-position="right" class="form marginTop30">
        <div class="fsize24 marginBom48 fcolor_black">其他信息</div>
        <!-- 学历 -->
        <div class="education marginBom38">
          <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
            <span class="fcolor_black required">主要学历</span>
            <el-button class="btn" type="primary" @click="showAddEducationState = true">新增</el-button>（学历从高中起）
          </div>
          <div class="content">
            <el-table border :data="form.applyStudyList" style="width: 100%">
              <el-table-column min-width="150" align="center">
                <span slot-scope="scope">
                  {{ scope.$index + 1 == form.applyStudyList.length ? '最高学历院校' : '' }}
                </span>
              </el-table-column>
              <el-table-column prop="date" label="起止年月" min-width="200" align="center">
                <span slot-scope="scope">{{ scope.row.studyBeginDate }}~{{ scope.row.studyEndDate }}</span>
              </el-table-column>
              <el-table-column prop="schoolName" label="学校名称" min-width="230" align="center"></el-table-column>
              <el-table-column prop="studyEducation" label="学历" min-width="150" align="center"></el-table-column>
              <el-table-column prop="major" label="专业" min-width="150" align="center"></el-table-column>
              <el-table-column min-width="200" label="操作" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" @click="showModifyEducation(scope.row)">修改</el-button>
                    <el-button type="text" @click="removeEducation(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 工作经历 -->
        <div class="work-experience marginBom38">
          <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
            <span class="fcolor_black required">主要工作经历</span>
            <el-button class="btn" type="primary" @click="showAddWorkExperience">新增</el-button>
          </div>
          <div class="content">
            <el-table border :data="form.applyWorkList" style="width: 100%">
              <el-table-column prop="date" label="起止年月" min-width="271" align="center">
                <span slot-scope="scope">{{ scope.row.workBeginDate }}~{{ scope.row.workEndDate }}</span>
              </el-table-column>
              <el-table-column prop="workPlace" label="工作单位名称" min-width="376" align="center"></el-table-column>
              <el-table-column prop="workDept" label="科室" min-width="221" align="center"></el-table-column>
              <el-table-column min-width="330" label="操作" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" @click="showModifyWorkExperience(scope.row)">修改</el-button>
                    <el-button type="text" @click="removeWorkExperience(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 政治表现 -->
        <div class="marginBom24 title">
          <el-form-item prop="politicalPerformance" label="政治表现">
            <el-input class="marginTop24" type="textarea" :rows="2" placeholder="请输入内容" v-model="form.applyBasic.politicalPerformance"></el-input>
          </el-form-item>
        </div>
        <!-- 专业水平 -->
        <div class="marginBom38 title">
          <el-form-item prop="professionalLevel" label="专业水平">
            <el-input class="marginTop24" type="textarea" :rows="2" placeholder="请输入内容" v-model="form.applyBasic.professionalLevel"></el-input>
          </el-form-item>
        </div>
        <!-- 外语水平 -->
        <div class="marginBom38 title">
          <el-form-item prop="foreignLanguageLevel" label="外语水平">
            <el-input class="marginTop24" type="textarea" :rows="2" placeholder="请输入内容" v-model="form.applyBasic.foreignLanguageLevel"></el-input>
          </el-form-item>
        </div>
        <!-- 附件上传 -->
        <div class="upload marginBom38">
          <div class="fsize22 flex-yCenter">
            <span class="fcolor_black">附件上传</span>
          </div>
          <div class="content" v-if="dict.type.administrative_att_type">
            <div class="uploadBox marginTop24" v-for="item in dict.type.administrative_att_type" :key="item.value">
              <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
                <span :class="item.raw.remark == 'required' ? 'required' : ''">{{ item.label }}</span>
                <FileUpload
                  ref="upload"
                  :isShowTip="false"
                  class="avatar-uploader pr marginRt10"
                  @on-success="uploadSuccess"
                  id="1"
                  multiple
                  :before-upload="beforeAvatarUpload"
                  :fileType="['png', 'jpg', 'jpeg']"
                >
                  <template #content>
                    <el-button slot="trigger" type="primary" class="btn" style="width: 96px; height: 36px" @click="uploadType = item.value">上传</el-button>
                  </template>
                </FileUpload>
              </div>
              <el-table border :data="form.applyAttList.filter(sonItem => sonItem.attType == item.value)" style="width: 100%">
                <el-table-column prop="attName" label="文件名称" min-width="828" align="center"></el-table-column>
                <el-table-column min-width="370" label="操作" align="center">
                  <template slot-scope="scope">
                    <div>
                      <el-button type="text" @click="removeAtt(scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <span v-if="item.raw.remark != 'required' && item.raw.remark" class="fcolor_gray">（{{ item.raw.remark }}）</span>
            </div>
          </div>
        </div>
        <div class="overflow staging marginBom30">
          <el-button class="fr blueBtn2 btn300" type="primary" @click="staging">保存此页信息</el-button>
        </div>
        <div class="footer fr">
          <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(2)">1</a>
          <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(3)">2</a>
          <a class="a backIndex active fcolor_blue2 fsize22" @click="goPage(4)">3</a>
          <el-button class="fr submit btn300 blueBtn1" @click="submit" type="primary">下一步</el-button>
        </div>
        <div class="fr fcolor_red marginBom30" style="text-align: right; clear: both">请务必完整填写和上传所有自己拥有的信息，如职称证书等。如上传不完整会被驳回，需重新提交申请。</div>
      </el-form>
    </div>
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="showAddEducationState" :before-close="hiddenAddEducation" width="600px">
      <span slot="title" class="fsize28">新增</span>
      <el-form inline :rules="modifyEducationRules" ref="addEducation" :model="addEducationForm" label-position="right" label-width="130px">
        <div>
          <el-form-item style="display: flex" label="起止日期：" prop="date">
            <el-date-picker
              v-model="addEducationForm.date"
              type="monthrange"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div>
          <el-form-item style="display: flex" label="学校名称：" prop="schoolName">
            <el-input v-model="addEducationForm.schoolName" style="width: 100%"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item style="display: flex" label="学历：" prop="studyEducation">
            <el-select v-model="addEducationForm.studyEducation" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in [{ value: '高中' }, { value: '大专' }, { value: '本科' }, { value: '硕士' }, { value: '博士' }, { value: '其他' }]"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item style="display: flex" label="专业：" prop="major">
            <el-input v-model="addEducationForm.major" style="width: 100%"></el-input>
            <div class="fcolor_gray" style="line-height: inherit">（高中时期请填写: 理工、文史、综合、其他）</div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hiddenAddEducation">取 消</el-button>
        <el-button class="blueBtn1" @click="addEducation">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改学历 -->
    <Modal :showState="modifyEducationState" @cancel="modifyEducationCancel" title="修改" @confirm="modifyEducationConfirm">
      <template #content>
        <el-form inline :rules="modifyEducationRules" ref="modifyEducation" :model="modifyEducationForm" label-position="right" label-width="130px">
          <div>
            <el-form-item style="display: flex" label="起止日期：" prop="date">
              <el-date-picker
                v-model="modifyEducationForm.date"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                value-format="yyyy-MM"
                format="yyyy-MM"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" label="学校名称：" prop="schoolName">
              <el-input v-model="modifyEducationForm.schoolName" style="width: 100%"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" label="学历：" prop="studyEducation">
              <el-select v-model="modifyEducationForm.studyEducation" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in [{ value: '高中' }, { value: '大专' }, { value: '本科' }, { value: '硕士' }, { value: '博士' }, { value: '其他' }]"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" label="专业：" prop="major">
              <el-input v-model="modifyEducationForm.major" style="width: 100%"></el-input>
              <div class="fcolor_gray" style="line-height: inherit">（高中时期请填写: 理工、文史、综合、其他）</div>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </Modal>
    <!-- 新增工作经历 -->
    <Modal :showState="addWorkExperienceState" @cancel="addWorkExperienceCancel" title="新增" @confirm="addWorkExperienceConfirm">
      <template #content>
        <el-form ref="addWorkExperience" :rules="addWorkExperienceRules" inline :model="addWorkExperienceForm" label-position="right">
          <div>
            <el-form-item style="display: flex" prop="date" label="起止日期：">
              <el-date-picker
                v-model="addWorkExperienceForm.date"
                type="monthrange"
                value-format="yyyy-MM"
                format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" prop="workPlace" label="工作单位：">
              <el-input v-model="addWorkExperienceForm.workPlace" style="width: 100%"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" prop="workDept" label="工作科室：">
              <el-input v-model="addWorkExperienceForm.workDept" style="width: 100%" maxlength="32"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </Modal>
    <!-- 修改工作经历 -->
    <Modal :showState="modifyWorkExperienceState" @cancel="modifyWorkExperienceCancel" title="修改" @confirm="modifyWorkExperienceConfirm">
      <template #content>
        <el-form ref="modifyWorkExperience" :rules="modifyWorkExperienceRules" inline :model="modifyWorkExperienceForm" label-position="right">
          <div>
            <el-form-item style="display: flex" prop="date" label="起止日期：">
              <el-date-picker
                v-model="modifyWorkExperienceForm.date"
                value-format="yyyy-MM"
                format="yyyy-MM"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" prop="workPlace" label="工作单位：">
              <el-input v-model="modifyWorkExperienceForm.workPlace" style="width: 100%"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex" prop="workDept" label="工作科室：">
              <el-input v-model="modifyWorkExperienceForm.workDept" style="width: 100%" maxlength="32"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </Modal>
  </div>
</template>
<script>
import { getApplyStorage, stagingApplyStorageAdmin, trainApplyAdmin, testDate } from '@/utils/api'
import { parseTime } from '@/utils/ruoyi'
import Modal from '@/views/components/modal.vue'
import { v4 as uuidv4 } from 'uuid'
export default {
  components: {
    Modal
  },
  dicts: ['administrative_att_type', 'special_items'],
  data() {
    return {
      form: {
        trainType: this.$route.query.type,
        applyBasic: {},
        applyStudyList: [],
        applyWorkList: [],
        applyAttList: []
      },
      // 新增学历显示状态
      showAddEducationState: false,
      // 新增学历表单
      addEducationForm: {
        date: [],
        schoolName: '',
        major: '',
        studyEducation: ''
      },
      // 修改学历显示状态
      modifyEducationState: false,
      // 修改学历表单
      modifyEducationForm: {},
      // 学历校验
      modifyEducationRules: {
        date: [{ required: true, trigger: 'change', message: '日期不能为空' }],
        schoolName: [{ required: true, trigger: 'blur', message: '学校名称不能为空' }],
        studyEducation: [{ required: true, trigger: 'change', message: '学历不能为空' }],
        major: [{ required: true, trigger: 'blur', message: '专业不能为空' }]
      },
      // 新增工作经历显示状态
      addWorkExperienceState: false,
      // 新增工作经历表单
      addWorkExperienceForm: {},
      // 新增工作经历表单校验
      addWorkExperienceRules: {
        date: [{ required: true, trigger: 'change', message: '日期不能为空' }],
        workPlace: [{ required: true, trigger: 'blur', message: '工作单位不能为空' }],
        workDept: [{ required: true, trigger: 'blur', message: '科室不能为空' }]
      },
      // 修改工作经历显示状态
      modifyWorkExperienceState: false,
      // 修改工作经历表单
      modifyWorkExperienceForm: {},
      // 修改工作经历表单校验
      modifyWorkExperienceRules: {
        date: [{ required: true, trigger: 'change', message: '日期不能为空' }],
        workPlace: [{ required: true, trigger: 'blur', message: '工作单位不能为空' }],
        workDept: [{ required: true, trigger: 'blur', message: '科室不能为空' }]
      },
      rules: {}
    }
  },
  created() {
    this.form = this.$parent.administrativeForm
    this.form.applyStudyList.forEach(item => {
      item.uuid = uuidv4()
    })
    this.form.applyWorkList.forEach(item => {
      item.uuid = uuidv4()
    })
  },
  methods: {
    // 新增学历
    addEducation() {
      let that = this
      this.$refs.addEducation.validate(vaild => {
        if (vaild) {
          {
            // 筛选学校是否重复
            // let list = this.form.applyStudyList.filter(
            //   (item) => item.schoolName == that.addEducationForm.schoolName
            // );
            // if (list.length != 0) {
            //   that.$message.warning("学历记录已填写该学校");
            //   return;
            // }
            // 新增并关闭弹窗
            that.form.applyStudyList.push({
              studyBeginDate: that.addEducationForm.date[0],
              studyEndDate: that.addEducationForm.date[1],
              schoolName: that.addEducationForm.schoolName,
              major: that.addEducationForm.major,
              studyEducation: that.addEducationForm.studyEducation,
              uuid: uuidv4()
            })
            this.hiddenAddEducation()
          }
        }
      })
    },
    // 关闭新增学历窗口前清除数据
    hiddenAddEducation(done) {
      this.addEducationForm = {
        date: [],
        schoolName: '',
        major: '',
        studyEducation: ''
      }
      if (typeof done == 'function') {
        done()
      } else {
        this.showAddEducationState = false
        this.$refs.addEducation.resetFields()
      }
    },
    // 删除学历信息
    removeEducation(obj) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.applyStudyList.forEach((item, index) => {
          if (item.uuid == obj.uuid) {
            this.form.applyStudyList.splice(index, 1)
          }
        })
      })
    },
    // 打开修改学历
    showModifyEducation(obj) {
      this.modifyEducationState = true
      obj.date = [obj.studyBeginDate, obj.studyEndDate]
      this.modifyEducationForm = JSON.parse(JSON.stringify(obj))
    },
    // 修改学历确认
    modifyEducationConfirm() {
      let that = this
      this.$refs.modifyEducation.validate(vaild => {
        if (vaild) {
          this.form.applyStudyList.forEach((item, index) => {
            if (item.uuid == that.modifyEducationForm.uuid) {
              item.studyBeginDate = that.modifyEducationForm.date[0]
              item.studyEndDate = that.modifyEducationForm.date[1]
              ;(item.schoolName = that.modifyEducationForm.schoolName),
                (item.major = that.modifyEducationForm.major),
                (item.studyEducation = that.modifyEducationForm.studyEducation),
                that.modifyEducationCancel()
            }
          })
        }
      })
    },
    // 关闭修改学历
    modifyEducationCancel() {
      this.modifyEducationState = false
    },
    // 打开新增工作经历
    showAddWorkExperience() {
      this.addWorkExperienceState = true
    },
    // 确认新增工作经历
    addWorkExperienceConfirm() {
      let that = this
      console.log(that.addWorkExperienceForm)
      // return
      this.$refs.addWorkExperience.validate(valid => {
        if (valid == true) {
          // 新增并关闭弹窗
          that.form.applyWorkList.push({
            workBeginDate: that.addWorkExperienceForm.date[0],
            workEndDate: that.addWorkExperienceForm.date[1],
            workPlace: that.addWorkExperienceForm.workPlace,
            workDept: that.addWorkExperienceForm.workDept,
            uuid: uuidv4()
          })
          this.addWorkExperienceCancel()
        }
      })
    },
    // 关闭新增工作经历
    addWorkExperienceCancel() {
      this.addWorkExperienceForm = {}
      this.$refs.addWorkExperience.resetFields()
      this.addWorkExperienceState = false
    },
    // 删除工作经历
    removeWorkExperience(obj) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.applyWorkList.forEach((item, index) => {
          if (item.uuid == obj.uuid) {
            this.form.applyWorkList.splice(index, 1)
          }
        })
      })
    },
    // 打开修改工作经历
    showModifyWorkExperience(obj) {
      this.modifyWorkExperienceState = true
      obj.date = [obj.workBeginDate, obj.workEndDate]
      this.modifyWorkExperienceForm = JSON.parse(JSON.stringify(obj))
    },
    // 修改工作经历确认
    modifyWorkExperienceConfirm() {
      let that = this
      this.form.applyWorkList.forEach((item, index) => {
        if (item.uuid == that.modifyWorkExperienceForm.uuid) {
          item.workBeginDate = that.modifyWorkExperienceForm.date[0]
          item.workEndDate = that.modifyWorkExperienceForm.date[1]
          item.workPlace = that.modifyWorkExperienceForm.workPlace
          item.workDept = that.modifyWorkExperienceForm.workDept
          that.modifyWorkExperienceCancel()
        }
      })
    },
    // 关闭修改工作经历
    modifyWorkExperienceCancel() {
      this.modifyWorkExperienceState = false
      this.$refs.modifyWorkExperience.resetFields()
    },
    // 文件上传前
    beforeAvatarUpload(file) {
      console.log(file)
      let typeList = ['image/jpeg', 'image/png', 'image/jpg']
      const isJPG = typeList.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG与PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    // 上传文件成功时
    uploadSuccess(res, file, list, d) {
      let that = this
      this.form.applyAttList.push({
        attType: that.uploadType,
        attName: res.originalFilename,
        attUrl: res.url
      })
    },
    // 删除附件
    removeAtt(obj) {
      let that = this
      that
        .$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          that.form.applyAttList.forEach((item, index) => {
            if (item.attUrl == obj.attUrl) {
              that.form.applyAttList.splice(index, 1)
            }
          })
        })
    },
    goPage(val) {
      this.form.applyStudyList.sort((a, b) => a.studyBeginDate.localeCompare(b.studyBeginDate))
      this.form.applyAttList.forEach((item, index) => {
        if (!item.attType) {
          this.form.applyAttList.splice(index, 1)
        }
      })
      stagingApplyStorageAdmin(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success('暂存信息成功')
          this.$parent.active = val
        }
      })
    },
    // 保存此页信息
    staging() {
      this.form.applyStudyList.sort((a, b) => a.studyBeginDate.localeCompare(b.studyBeginDate))
      this.form.applyAttList.forEach((item, index) => {
        if (!item.attType) {
          this.form.applyAttList.splice(index, 1)
        }
      })
      stagingApplyStorageAdmin(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success('暂存信息成功')
        }
      })
    },
    // 提交
    submit(e) {
      let that = this
      // return
      let is = true
      that.form.applyStudyList.sort((a, b) => a.studyBeginDate.localeCompare(b.studyBeginDate))
      for (let i = 0; i < that.dict.type.administrative_att_type.length; i++) {
        const item = that.dict.type.administrative_att_type[i]
        if (item.raw.remark == 'required') {
          if (that.form.applyAttList.filter(s => s.attType == item.value).length == 0) {
            that.$message.error(item.label + '是必传的')
            is = false
            break
          }
        }
      }
      if (is == false) {
        return
      }
      if (
        that.dict.type.special_items.filter(item => item.value == that.form.applyBasic.specialItems).length > 0 &&
        that.dict.type.special_items.filter(item => item.value == that.form.applyBasic.specialItems)[0].raw.remark == 'other'
      ) {
        if (!that.form.applyBasic.specialItemsOther) {
          that.$message.error('其他项目补充未填写')
          return
        }
      }
      that.form.applyAttList = that.form.applyAttList.filter(item => item.attType)
      this.$nextTick(() => {
        testDate(this.form.applyDeptList[0].beginDate)
          .then(res => {
            if (res.code == 200) {
              this.submitForm(this.form)
            }
          })
          .catch(err => {
            const h = this.$createElement
            this.$confirm('已超过报名截止时间，报名无效?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              message: h('p', null, [h('p', null, '已超过报名截止时间，报名无效'), h('p', { style: 'margin-top: 0px;color: #9999ad' }, '确定还要提交信息吗？')])
            })
              .then(() => {
                this.submitForm(this.form)
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          })
        // this.submitForm(this.form)
        // 以服务的方式调用的 Loading 需要异步关闭
      })
    },
    submitForm(form) {
      const loading = this.$loading({
        lock: true,
        text: '进修申请表生成中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        trainApplyAdmin(this.form)
          .then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功')
              setTimeout(() => {
                this.$parent.active = 5
                this.$parent.progress = 3
                this.$parent.applyId = res.data.applyId
              }, 500)
            }
          })
          .finally(e => {
            loading.close()
          })
      })
    },
    compareDate(dateTime1, dateTime2) {
      var formatDate1 = new Date(dateTime1)
      var formatDate2 = new Date(dateTime2)
      if (formatDate1 > formatDate2) {
        return formatDate1
      } else {
        return formatDate2
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .title .el-form-item__label {
  font-size: 22px;
  color: #333;
  padding: 0;
}

::v-deep .el-form-item__content {
  flex-grow: 1;
}

.el-button--primary {
  padding: 0;
}

.backIndex:hover {
  cursor: pointer;
}

.formTitle {
  margin: 50px 0px 30px 240px;
}

.step {
  margin-bottom: 50px;
}

::v-deep .el-textarea__inner {
  height: 95px;
  font-size: 18px;
}

::v-deep.form {
  margin-bottom: 47px;
  overflow: hidden;

  .footer {
    .a {
      display: inline-block;
      width: 40px;
      line-height: 36px;
      text-align: center;
      border-radius: 5px;
      height: 40px;
      color: #333;
      border: #999999 solid 2px;
      margin-left: 30px;

      &:hover {
        border-color: #2d53c8;
      }
    }

    & > .a:last-child {
      width: 110px;
    }

    & > .active {
      border-color: #2d53c8;
    }
  }

  .submit {
    margin-left: 27px;
  }
}
</style>
